import AddPdfTemplateForm from './AddPdfTemplateForm';

export default AddPdfTemplateForm;
